import { Helmet } from "react-helmet-async"
import { ErrorView } from "shared/ui/errorView"
import React from "react"

// ----------------------------------------------------------------------

export function Page500(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>500 - серверная ошибка</title>
      </Helmet>

      <ErrorView
        label="500"
        title="Что-то пошло не так..."
        description="Произошла ошибка на стороне сервера. Нам жаль, что так вышло. Постараемся сделать все, чтобы это не
          повторилось."
      />
    </>
  )
}
